import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import routes from "./routes/routes";
import "./App.css";
import Header from "../src/components/client-side/global/Header";
import Footer from "./components/client-side/global/Footer";
import { RegionProvider } from "./context/RegionContext";
import { CTAProvider } from "./context/CTAContext";
import { pageview } from "./analytics";
import ScrollToTop from "./components/client-side/global/ScrollToTop";

const AppContent = () => {
  const location = useLocation();
  const hidePublicLayout = location.pathname.startsWith("/campaign/");

  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location.pathname, location.search]);

  const renderRoutes = (routesArray) =>
    routesArray.map(({ path, element: Element }) => (
      <Route key={path} path={path} element={<Element />} />
    ));

  return (
    <div className="App">
      {!hidePublicLayout && <Header />}

      <main>
        <Routes>
          {renderRoutes(routes.public)}
          {renderRoutes(routes.dashboard)}
        </Routes>
      </main>

      {!hidePublicLayout && <Footer />}
    </div>
  );
};

function App() {
  return (
    <Router>
      <RegionProvider>
        <CTAProvider>
          <AppContent />
          <ScrollToTop />
        </CTAProvider>
      </RegionProvider>
    </Router>
  );
}

export default App;
